// date.actions.ts
import { createAction, props } from '@ngrx/store';
import { DateTime } from 'luxon';

export const setSelectedDate = createAction('[Date] Set Selected Date', props<{ selectedDate: DateTime }>());
export const clearSelectedDate = createAction('[Date] Clear Selected Date');
